export default "https://assets.egbcdn.net/assets/packs/_/images/landing-ladder/streamers/team-photo-93f52c490b0d67d071878f3cc78a3c64.svg";